module.exports = __webpack_public_path__ + "img/files-documents.3374a9c3.png";